var gvUrl=window.gvUrl||(window.gvUrl=function(p){var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';return r+String(p).replace(/^\//,'')});
var gvTr=window.gvTr||(window.gvTr=function(k,f){var d=window.GV_I18N;return d&&d[k]!=null?d[k]:f});
/* Galand Vanille — module d'achat v4 des fiches vanille (particuliers et pro).
   Maquette validée par Paul le 24/09/2026 (maquette-module-achat-v4.html).

   Données : <script data-gvma-data> rendu par snippets/gv-module-achat.liquid.
   Ajout au panier : même chemin que l'ancien bloc — POST /cart/add.js (vanille + tubes payants),
   puis l'événement cart:updated, qui recharge et ouvre le panier latéral. La propriété « Pour »
   des tubes est ajoutée par l'intercepteur de w-main-product-form.liquid ; le tube offert des
   givrées est ajouté par gv-cadeaux.js (le module n'envoie donc jamais de tube offert).
   Prix remisés : remise par unité arrondie au centime inférieur, comme Shopify.
   Repères de format : GV.sizeInfo (assets/gv-selector.js, chargé en defer : lu dès qu'il existe). */
(function () {
  'use strict';
  var MOI = document.currentScript && document.currentScript.src;

  /* ───────────── outils ───────────── */
  function eur(c) {
    var n = Math.round(c);
    var e = Math.floor(n / 100), ct = n % 100;
    return String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + (ct < 10 ? '0' : '') + ct + ' €';
  }
  function esc(t) {
    return String(t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function nettoie(t) { return String(t || '').replace(/[«»]/g, ' ').replace(/\s+/g, ' ').trim(); }
  function sizeInfo(cm) { return (window.GV && GV.sizeInfo && GV.sizeInfo[cm]) || null; }
  /* Nom de format AFFICHÉ dans la langue du visiteur (chantier traduction, 31/10/2026) : GV.sizeInfo[..].name reste
     le nom français, clé de USAGE et du choix du texte de la fenêtre « i ». */
  function nomLisible(n) { return (window.GV && GV.nomLisible) ? GV.nomLisible(n) : n; }

  /* Titre de variante → description structurée.
     « 5 Gousses 17/19cm », « 1 Gousse +13cm », « 1 Gousse fendue 12/15g », « 250g 13/15cm », « 1Kg ». */
  function analyse(v) {
    var t = nettoie(v.t), low = t.toLowerCase();
    var cmM = low.match(/(\+?\d+(?:\/\d+)?)\s*cm\b/);
    var cm = cmM ? cmM[1] + ' cm' : '';
    var it = { id: v.id, t: t, p: v.p, a: !!v.a, cm: cm, ref: (v.c && v.c > v.p) ? v.c : v.p, stock: v.s, vt: v.t, tb: v.tb };
    /* fiche du tube en verre (25/09) : « 1 tube », « 5 tubes », « 10 tubes », « 20 tubes » */
    var tM = low.match(new RegExp('^(\\d+)\\s*' + gvTr('gv.logique.re_tubes_html', 'tubes?') + '\\b'));
    if (tM) { it.kind = 'tube'; it.q = parseInt(tM[1], 10); return it; }
    if (low.indexOf(gvTr('gv.logique.gousse_html', 'gousse')) !== -1) {
      var qM = low.match(new RegExp('^(\\d+)\\s*' + gvTr('gv.logique.re_gousses_html', 'gousses?')));
      it.kind = 'gousse';
      it.q = qM ? parseInt(qM[1], 10) : 1;
      var reste = low.replace(new RegExp('^(\\d+)\\s*' + gvTr('gv.logique.re_gousses_html', 'gousses?')), '').replace(/(\+?\d+(?:\/\d+)?)\s*cm\b/, '');
      var gM = reste.match(/(\d+(?:\/\d+)?)\s*g\b/);
      it.g = gM ? gM[1] + ' g' : '';
      it.extra = reste.replace(/(\d+(?:\/\d+)?)\s*g\b/, '').replace(/\s+/g, ' ').trim();
    } else {
      var wM = low.match(/(\d+(?:[.,]\d+)?)\s*(kg|g)\b/);
      it.kind = 'vrac';
      it.grams = wM ? Math.round(parseFloat(wM[1].replace(',', '.')) * (wM[2] === 'kg' ? 1000 : 1)) : 0;
      it.q = 1;
    }
    return it;
  }
  function poidsLisible(g) {
    if (!g) return '';
    if (g >= 1000 && g % 1000 === 0) return (g / 1000) + ' kg';
    if (g >= 1000) return String(g / 1000).replace('.', ',') + ' kg';
    return g + ' g';
  }
  /* Estimation du nombre de gousses d'un poids : règle reprise de l'ancien bloc
     (1 kg ≈ 250, 500 g ≈ 120, 250 g ≈ 60, 125 g ≈ 30, corrigée selon le calibre). */
  function estimeGousses(grams, cm) {
    var e = grams >= 1000 ? 250 : grams === 500 ? 120 : grams === 250 ? 60 : grams === 125 ? 30 : 0;
    if (/16\/18/.test(cm)) e = Math.floor(e * 80 / 100);
    else if (/10\/12/.test(cm)) e = Math.floor(e * 112 / 100);
    else if (/18\/20|19\/21/.test(cm)) e = Math.floor(e * 65 / 100);
    return e;
  }

  /* Noms lisibles des calibres au poids et des longueurs minimales : mêmes échelles que
     w-variant-cards.js (« Libellés lisibles sur la FICHE PRODUIT », demande Paul du 22/09/2026). */
  var RARE = /pompona|chamissonis|cribbiana|sotoarenasii|odorata|bahiana/i;
  var ECHELLE = {
    rare: { 2: [gvTr('gv.gv_module_achat_js.ech_decouverte_html', 'Découverte'), gvTr('gv.gv_module_achat_js.ech_exception_html', 'Exception')], 3: [gvTr('gv.gv_module_achat_js.ech_decouverte_html', 'Découverte'), gvTr('gv.gv_module_achat_js.ech_genereuse_html', 'Généreuse'), gvTr('gv.gv_module_achat_js.ech_exception_html', 'Exception')],
      4: [gvTr('gv.gv_module_achat_js.ech_decouverte_html', 'Découverte'), gvTr('gv.gv_module_achat_js.ech_genereuse_html', 'Généreuse'), gvTr('gv.gv_module_achat_js.ech_grande_html', 'Grande'), gvTr('gv.gv_module_achat_js.ech_exception_html', 'Exception')] },
    courant: { 2: [gvTr('gv.gv_module_achat_js.ech_petit_html', 'Petit calibre'), gvTr('gv.gv_module_achat_js.ech_gros_html', 'Gros calibre')], 3: [gvTr('gv.gv_module_achat_js.ech_petit_html', 'Petit calibre'), gvTr('gv.gv_module_achat_js.ech_moyen_html', 'Calibre moyen'), gvTr('gv.gv_module_achat_js.ech_gros_html', 'Gros calibre')],
      4: [gvTr('gv.gv_module_achat_js.ech_petit_html', 'Petit calibre'), gvTr('gv.gv_module_achat_js.ech_moyen_html', 'Calibre moyen'), gvTr('gv.gv_module_achat_js.ech_grand_html', 'Grand calibre'), gvTr('gv.gv_module_achat_js.ech_tres_gros_html', 'Très gros calibre')] }
  };
  function echelle(data, n) {
    var rare = data.rare != null ? data.rare : RARE.test((typeof location !== 'undefined' && location.pathname) || '');
    return ECHELLE[rare ? 'rare' : 'courant'][n] || null;
  }
  function premierNombre(t) { var m = String(t || '').match(/\d+/); return m ? +m[0] : 0; }

  /* Variantes → formats (pastilles) → groupes (tuiles). */
  function construit(data) {
    var taux = +data.taux || 0;
    var items = data.variants.map(function (v) {
      var it = analyse(v);
      it.f = it.p - Math.floor(it.p * taux / 100);
      return it;
    });
    var G = items.filter(function (i) { return i.kind === 'gousse'; });
    var V = items.filter(function (i) { return i.kind === 'vrac'; });
    var T = items.filter(function (i) { return i.kind === 'tube'; });
    var formats = [];
    function grouper(liste) {
      var ordre = [], par = {};
      liste.forEach(function (i) {
        if (!par[i.cm]) { par[i.cm] = []; ordre.push(i.cm); }
        par[i.cm].push(i);
      });
      return ordre.map(function (cm) { return { cm: cm, items: par[cm] }; });
    }
    var calibres = G.length >= 2 && G.every(function (i) { return i.q === 1; });
    if (calibres) {
      formats.push({ type: 'cal', label: gvTr('gv.gv_module_achat_js.gousses_titre_html', 'Gousses'), groups: [{ cm: '', items: G }] });
    } else if (G.length) {
      grouper(G).forEach(function (g) {
        formats.push({ type: 'gousse', label: g.cm || gvTr('gv.gv_module_achat_js.gousses_titre_html', 'Gousses'), cm: g.cm, groups: [g] });
      });
      /* longueurs minimales (« +13 cm », « +24 cm ») : nom de l'échelle sur la pastille */
      var plus = formats.filter(function (f) { return /^\+\d+ cm$/.test(f.cm || ''); });
      var echP = plus.length >= 2 ? echelle(data, plus.length) : null;
      if (echP) plus.slice().sort(function (a, b) { return premierNombre(a.cm) - premierNombre(b.cm); })
        .forEach(function (f, i) { f.nom = echP[i]; f.label = echP[i]; });
    }
    if (T.length) formats.push({ type: 'tube', label: gvTr('gv.gv_module_achat_js.tubes_titre_html', 'Tubes'), groups: [{ cm: '', items: T }] });
    if (V.length) {
      var gv = grouper(V);
      if (G.length) formats.push({ type: 'vrac', label: gvTr('gv.gv_module_achat_js.en_vrac_html', 'En vrac'), groups: gv });
      else gv.forEach(function (g) { formats.push({ type: 'vrac', label: g.cm || gvTr('gv.gv_module_achat_js.au_poids_html', 'Au poids'), cm: g.cm, groups: [g] }); });
    }
    /* chiffres de chaque tuile */
    formats.forEach(function (fm) {
      fm.groups.forEach(function (g) {
        if (fm.type === 'tube') {
          var refT = g.items.filter(function (i) { return i.q === 1; })[0] ||
            g.items.slice().sort(function (a, b) { return a.q - b.q; })[0];
          var baseT = refT.p / refT.q;
          g.maxR = 0;
          g.items.forEach(function (i) {
            i.label = i.q + (i.q > 1 ? gvTr('gv.gv_module_achat_js.tubes_n_html', ' tubes') : gvTr('gv.gv_module_achat_js.tube_n_html', ' tube'));
            i.r = Math.round((1 - (i.p / i.q) / baseT) * 100);
            if (i.r > g.maxR) g.maxR = i.r;
            i.unit = eur(Math.floor(i.f / i.q)) + gvTr('gv.gv_module_achat_js.par_tube_html', '/tube');
            i.pastille = i.r > 0 ? { t: '−' + i.r + gvTr('gv.gv_module_achat_js.pct_html', ' %') } : null;
          });
          if (g.maxR > 0) g.items.forEach(function (i) { if (i.q === 1 && !i.pastille) i.pastille = { t: gvTr('gv.gv_module_achat_js.a_l_unite_html', 'à l’unité'), neutre: 1 }; });
        } else if (fm.type === 'gousse') {
          var ref = g.items.filter(function (i) { return i.q === 1; })[0] ||
            g.items.slice().sort(function (a, b) { return a.q - b.q; })[0];
          var base = ref.p / ref.q;
          g.maxR = 0;
          g.items.forEach(function (i) {
            i.label = i.q + (i.q > 1 ? gvTr('gv.gv_module_achat_js.gousses_n_html', ' gousses') : gvTr('gv.gv_module_achat_js.gousse_n_html', ' gousse'));
            i.r = Math.round((1 - (i.p / i.q) / base) * 100);
            if (i.r > g.maxR) g.maxR = i.r;
            i.unit = eur(Math.floor(i.f / i.q)) + gvTr('gv.gv_module_achat_js.par_gousse_html', '/gousse');
            i.pastille = i.r > 0 ? { t: '−' + i.r + gvTr('gv.gv_module_achat_js.pct_html', ' %') } : i.q === 1 ? { t: gvTr('gv.gv_module_achat_js.a_l_unite_html', 'à l’unité'), neutre: 1 } : null;
          });
        } else if (fm.type === 'vrac') {
          var petit = g.items.filter(function (i) { return i.grams > 0; })
            .sort(function (a, b) { return a.grams - b.grams; })[0];
          var baseKg = petit ? petit.p / (petit.grams / 1000) : 0;
          g.items.forEach(function (i) {
            i.label = poidsLisible(i.grams) || i.t;
            var env = data.brut ? 0 : estimeGousses(i.grams, i.cm);
            i.sub = env ? gvTr('gv.gv_module_achat_js.env_html', 'env. ') + env + gvTr('gv.gv_module_achat_js.gousses_n_html', ' gousses') : '';
            i.unit = data.brut ? (i.grams ? gvTr('gv.gv_module_achat_js.soit_html', 'soit ') + eur(Math.floor(i.f * 1000 / i.grams)) + '/kg' : '')
              : (env ? '≈ ' + eur(Math.floor(i.f / env)) + gvTr('gv.gv_module_achat_js.par_gousse_html', '/gousse') : '');
            var r = (baseKg && i.grams) ? Math.round((1 - (i.p / (i.grams / 1000)) / baseKg) * 100) : 0;
            i.pastille = r > 0 ? { t: '−' + r + gvTr('gv.gv_module_achat_js.pct_au_kg_html', ' % au kg') } : { t: gvTr('gv.gv_module_achat_js.au_poids_pastille_html', 'au poids'), neutre: 1 };
          });
        } else {
          /* mode calibres : nom de l'échelle en titre, poids exact dessous ; la gousse fendue garde son nom */
          var pesees = g.items.filter(function (i) { return i.g && !new RegExp(gvTr('gv.logique_fiche.fendue_html', 'fendue')).test(i.extra); });
          var etrangeres = g.items.some(function (i) { return !i.g || (i.extra && !new RegExp(gvTr('gv.logique_fiche.fendue_html', 'fendue')).test(i.extra)); });
          var ech = (!etrangeres && pesees.length >= 2) ? echelle(data, pesees.length) : null;
          if (ech) pesees.slice().sort(function (a, b) { return premierNombre(a.g) - premierNombre(b.g); })
            .forEach(function (i, k) { i.nom = ech[k]; });
          g.items.forEach(function (i) {
            if (new RegExp(gvTr('gv.logique_fiche.fendue_html', 'fendue')).test(i.extra)) { i.label = gvTr('gv.gv_module_achat_js.gousse_fendue_html', 'Gousse fendue'); i.sub = i.g; }
            else if (i.nom) { i.label = i.nom; i.sub = i.g; }
            else { i.label = i.g || i.t; i.sub = gvTr('gv.gv_module_achat_js.une_gousse_html', '1 gousse') + (i.extra ? ' ' + i.extra : ''); }
            i.unit = '';
            i.pastille = null;
          });
        }
      });
    });
    /* « Meilleure affaire pro » : dernier format au poids disponible (règle de l'ancien bloc). */
    var dispoV = V.filter(function (i) { return i.a; });
    if (V.length >= 2 && dispoV.length) dispoV[dispoV.length - 1].best = true;
    return { formats: formats, items: items, calibres: calibres, hasG: G.length > 0, hasV: V.length > 0 };
  }

  /* Page coffret (29/09/2026) : une seule variante, rien à choisir. Modèle minimal (un format, un groupe,
     un article) pour réutiliser tel quel le bouton, les barres, l'ajout au panier et l'alerte de retour.
     Ne sert que si les données portent "mode": "coffret" (snippets/gv-module-coffret.liquid). */
  function modeleCoffret(data) {
    var taux = +data.taux || 0, v = data.variants[0] || {};
    var p = +v.p || 0, c = +v.c || 0;
    var it = { id: v.id, kind: 'coffret', label: data.titre, sub: '', p: p, ref: c > p ? c : p, a: !!v.a, stock: v.s > 0 ? +v.s : 0, q: 1 };
    it.f = p - Math.floor(p * taux / 100);
    return { formats: [{ type: 'coffret', groups: [{ cm: '', items: [it] }] }], items: [it], calibres: [], hasG: false, hasV: false };
  }

  /* ───────────── démarrage ───────────── */
  var root = document.querySelector('[data-gvma]:not([data-gvma-pret])');
  if (!root) return;
  root.setAttribute('data-gvma-pret', '1');
  var data;
  try { data = JSON.parse(root.querySelector('[data-gvma-data]').textContent); } catch (e) { return; }
  var COF = data.mode === 'coffret';
  var M = COF ? modeleCoffret(data) : construit(data);
  if (!M.items.length) return;
  /* gravure de la gousse : adresse fournie par le snippet, sinon voisine de ce fichier (même dossier assets) */
  var gousseSrc = data.gousse || (MOI ? MOI.replace(/gv-module-achat\.js(\?.*)?$/, 'gv-gousse-gravure.png') : '');
  window.GVMA = { data: data, modele: M, analyse: analyse, construit: construit };
  /* Hors français (chantier traduction, 31/10/2026) : « Pour » et « Format » du tube partent en FRANÇAIS, comme sur le
     site français (Flow « Étiquette tube → vanille », tableau d'étiquettes, Paul) : titres relus à l'adresse racine,
     sans préfixe de langue. Le panier relu à la racine retrouve aussi le tube de chaque format déjà au panier (règle
     de gv-module-achat.liquid, qui compare sur les titres traduits et ne trouve donc rien hors français).
     En français, rien de tout cela : FRP et FRV restent null. */
  var FRV = null, FRP = null;
  if ((window.GV_LANG || 'fr') !== 'fr' && data.handle && !COF && data.tube && !data.sansTube && !data.pro && !data.brut && !data.offert) {
    FRP = fetch('/products/' + encodeURIComponent(data.handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var vt = {};
        (p.variants || []).forEach(function (v) { vt[v.id] = v.title; });
        FRV = { titre: p.title, vt: vt };
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!data.tube || !FRV) return;
        M.items.forEach(function (it) {
          var l = (cart.items || []).filter(function (ci) {
            var pr = ci.properties || {};
            return (ci.handle === 'tube-en-verre-fond-plat-208mm' || ci.handle === 'tube-en-verre-fond-plat-pour-vanille') &&
              pr.Pour === FRV.titre && pr.Format === FRV.vt[it.id];
          })[0];
          if (l) it.tb = +l.variant_id !== +data.tube.id ? l.variant_id : undefined;
        });
      })
      .catch(function () {})
      .then(function () { FRV = FRV || {}; });
  }

  var st = { fmt: 0, grp: 0, id: null, tube: false, qty: 1, busy: false };
  var elChoix = root.querySelector('[data-gvma-choix]');
  var elAct = root.querySelector('[data-gvma-act]');
  var elErr = root.querySelector('[data-gvma-err]');

  function formatCourant() { return M.formats[st.fmt]; }
  function groupeCourant() { var f = formatCourant(); return f.groups[Math.min(st.grp, f.groups.length - 1)]; }
  function article() {
    var g = groupeCourant();
    return g.items.filter(function (i) { return String(i.id) === String(st.id); })[0] || g.items[0];
  }
  function premierDispo(items) { return items.filter(function (i) { return i.a; })[0] || items[0]; }
  function choisirFormat(fi, gi) {
    st.fmt = fi;
    var f = M.formats[fi];
    if (gi == null) {
      gi = 0;
      for (var k = 0; k < f.groups.length; k++) {
        if (f.groups[k].items.some(function (i) { return i.a; })) { gi = k; break; }
      }
    }
    st.grp = gi;
    st.id = premierDispo(f.groups[gi].items).id;
  }
  /* sélection de départ : le premier format qui a au moins une variante disponible */
  (function () {
    for (var fi = 0; fi < M.formats.length; fi++) {
      var f = M.formats[fi];
      for (var gi = 0; gi < f.groups.length; gi++) {
        if (f.groups[gi].items.some(function (i) { return i.a; })) { choisirFormat(fi, gi); return; }
      }
    }
    choisirFormat(0, 0);
  })();

  /* conditionnement : 'switch' | 'offert' | 'sachet' | 'aucun' */
  function conditionnement(it) {
    if (it.kind === 'coffret') return 'aucun'; /* page coffret : chaque vanille est déjà dans son tube */
    if (it.kind === 'tube') return 'aucun'; /* fiche du tube lui-même : ni tube en option, ni sachet */
    if (data.pro || data.brut) return 'aucun';
    if (it.kind === 'vrac') return 'sachet';
    if (data.offert) return 'offert';
    if (!data.tube || data.sansTube) return 'sachet';
    return 'switch';
  }
  function nbTubes(it) { return it.kind === 'gousse' ? Math.max(1, Math.ceil(it.q / 10)) : 1; }
  function qteMax() { var it = article(); return (it.stock > 0) ? it.stock : 99; }

  function calc() {
    var it = article(), cond = conditionnement(it);
    var tubesLot = (cond === 'switch' && st.tube && it.a) ? nbTubes(it) : 0;
    var tp = data.tube ? data.tube.p : 0;
    var prix = (it.f + tubesLot * tp) * st.qty;
    var brut = (it.ref + tubesLot * tp) * st.qty;
    var f = formatCourant();
    var sel = (st.qty > 1 ? st.qty + ' × ' : '');
    if (it.kind === 'vrac') {
      sel += it.label + (data.brut ? '' : gvTr('gv.gv_module_achat_js.en_vrac_sel_html', ' en vrac')) + (it.cm ? ' · ' + it.cm : '');
    } else if (f.type === 'cal') {
      sel += (it.label !== it.g ? it.label : it.sub) + (it.g ? ' · ' + it.g : '');
    } else {
      sel += it.label + (it.cm ? ' · ' + it.cm : '');
    }
    var tubesTot = tubesLot * st.qty;
    if (!it.a) { /* variante épuisée : pas de conditionnement dans le libellé */ }
    else if (cond === 'switch') sel += ' · ' + (tubesTot ? (tubesTot > 1 ? tubesTot + gvTr('gv.gv_module_achat_js.tubes_n_html', ' tubes') : gvTr('gv.gv_module_achat_js.en_tube_html', 'en tube')) : gvTr('gv.gv_module_achat_js.sachet_offert_html', 'sachet offert'));
    else if (cond === 'offert') sel += gvTr('gv.gv_module_achat_js.sel_tube_offert_html', ' · tube offert');
    else if (cond === 'sachet') sel += gvTr('gv.gv_module_achat_js.sel_sachet_offert_html', ' · sachet offert');
    if (COF) sel = (st.qty > 1 ? st.qty + ' × ' : '') + data.titre;
    return { it: it, cond: cond, tubesLot: tubesLot, prix: prix, brut: brut, remise: brut !== prix, sel: sel, oos: !it.a };
  }

  /* ───────────── repère de format (texte + jauge) ───────────── */
  /* Ligne de lecture sous les formats (retour Paul du 25/09 : la jauge ne disait rien) :
     nom du format · longueur, poids par gousse · usage, puis un lien texte vers la fenêtre de
     comparaison. Les usages reprennent les textes validés des fenêtres « i ». */
  var USAGE = { 'Format standard': gvTr('gv.gv_module_achat_js.usage_std_html', 'le plus polyvalent'), 'Plus petites': gvTr('gv.gv_module_achat_js.usage_pet_html', 'prix par gousse plus doux'), 'Grandes gousses': gvTr('gv.gv_module_achat_js.usage_grand_html', 'le plus grand calibre') };
  function repere(f) {
    /* « En vrac » à côté des formats en gousses */
    if (f.type === 'vrac' && !f.cm) {
      var sv = sizeInfo('En vrac');
      var w = sv && sv.w ? ((window.GV_LANG || 'fr') === 'de' ? sv.w : sv.w.charAt(0).toLowerCase() + sv.w.slice(1)) : gvTr('gv.gv_module_achat_js.vrac_degressif_html', 'prix dégressif au kilo');
      return { html: gvTr('gv.gv_module_achat_js.repere_au_poids_html', '<b>Au poids</b> · ') + esc(w), info: 'vrac', lien: gvTr('gv.gv_module_achat_js.lien_prix_kilo_html', 'Voir le prix au kilo') };
    }
    /* fiche vendue seulement au poids, par calibre (fiches pro) : même lecture que le calibre */
    if (f.type === 'vrac') {
      var rv = repere({ type: 'gousse', cm: f.cm });
      if (rv && rv.info) rv.lien = gvTr('gv.gv_module_achat_js.lien_calibres_html', 'Comparer les calibres');
      return rv;
    }
    if (f.type !== 'gousse' || !f.cm) return null;
    var m = f.cm.match(/^(\d+)\/(\d+) cm$/);
    if (!m) {
      var p = f.cm.match(/^\+(\d+) cm$/);
      return p ? { html: '<b>' + esc(f.nom || gvTr('gv.gv_module_achat_js.gousses_titre_html', 'Gousses')) + gvTr('gv.gv_module_achat_js.repere_plus_de_html', '</b> · plus de ') + p[1] + ' cm', info: null } : null;
    }
    var si = sizeInfo(f.cm) || {};
    var pm = (si.w || '').match(/(\d+)\s*-\s*(\d+)\s*g/);
    var usage = USAGE[si.name];
    return {
      html: (si.name ? '<b>' + esc(nomLisible(si.name)) + '</b> · ' : '') + m[1] + gvTr('gv.gv_module_achat_js.a_html', ' à ') + m[2] + ' cm' +
        (pm ? ', ' + pm[1] + gvTr('gv.gv_module_achat_js.a_html', ' à ') + pm[2] + gvTr('gv.gv_module_achat_js.g_la_gousse_html', ' g la gousse') : '') + (usage ? ' · ' + usage : ''),
      info: 'fmt',
      lien: gvTr('gv.gv_module_achat_js.lien_formats_html', 'Comparer les formats')
    };
  }
  function lienInfo(k, txt) {
    return '<button type="button" class="custom-button gvma-lien" data-gvma-info="' + k + '"><span class="gvma-lien__i" aria-hidden="true">i</span>' + esc(txt) + '</button>';
  }

  /* ───────────── rendu du choix (format, quantité, conditionnement) ───────────── */
  var SVG_I = 'i';
  function btnI(k, lab) {
    return '<button type="button" class="custom-button gvma-i" data-gvma-info="' + k + '" aria-label="' + esc(lab) + '">' + SVG_I + '</button>';
  }
  function tuile(it, sel) {
    var h = '<button type="button" class="custom-button gvma-tile' + (sel ? ' on' : '') + (it.a ? '' : ' oos') + (it.best ? ' has-rib' : '') +
      '" data-gvma-id="' + it.id + '" aria-pressed="' + (sel ? 'true' : 'false') + '">';
    if (it.best) h += gvTr('gv.gv_module_achat_js.meilleure_affaire_html', '<span class="gvma-rib">Meilleure affaire pro</span>');
    h += '<span class="gvma-q' + (String(it.label).length > 11 ? ' gvma-q--long' : '') + '">' + esc(it.label) + '</span>';
    if (it.sub) h += '<span class="gvma-n">' + esc(it.sub) + '</span>';
    h += '<span class="gvma-p">' + eur(it.f) + '</span>';
    if (it.ref > it.f) h += '<s class="gvma-o">' + eur(it.ref) + '</s>';
    if (it.unit) h += '<span class="gvma-u">' + esc(it.unit) + '</span>';
    /* stock réel des 3 derniers exemplaires (Chamissonis seulement, demande Paul du 17/09/2026) */
    if (it.a && it.stock > 0 && it.stock <= 3) h += '<span class="gvma-stock">' + (it.stock === 1 ? gvTr('gv.gv_module_achat_js.derniere_gousse_html', 'Dernière gousse') : gvTr('gv.gv_module_achat_js.plus_que_html', 'Plus que ') + it.stock + gvTr('gv.gv_module_achat_js.gousses_n_html', ' gousses')) + '</span>';
    if (!it.a) h += gvTr('gv.gv_module_achat_js.epuise_html', '<span class="gvma-e gvma-e--oos">Épuisé</span>');
    else if (it.pastille) h += '<span class="gvma-e' + (it.pastille.neutre ? ' neutre' : '') + '">' + esc(it.pastille.t) + '</span>';
    return h + '</button>';
  }

  function rendreChoix() {
    if (COF) return; /* page coffret : prix et « Dans le coffret » rendus par le serveur */
    var f = formatCourant(), g = groupeCourant(), c = calc(), it = c.it;
    var h = '';
    /* Format */
    var montrerFormat = M.formats.length > 1 || (M.formats.length === 1 && f.type !== 'cal' && !!f.cm);
    if (montrerFormat) {
      h += gvTr('gv.gv_module_achat_js.format_entete_html', '<div class="gvma-opt gvma-opt--fmt"><div class="gvma-row"><span class="gvma-k">Format</span><div class="gvma-chips" role="group" aria-label="Format">');
      M.formats.forEach(function (fm, i) {
        h += '<button type="button" class="custom-button gvma-chip' + (i === st.fmt ? ' on' : '') + '" data-gvma-fmt="' + i + '" aria-pressed="' + (i === st.fmt) + '">' + esc(fm.label) + '</button>';
      });
      h += '</div></div>';
      var rp = repere(f);
      if (rp) {
        h += '<div class="gvma-fi"><span class="gvma-ft">' + rp.html + '</span>' +
          (rp.info ? lienInfo(rp.info, rp.lien) : '') + '</div>';
      }
      h += '</div>';
    }
    /* Quantité / calibre */
    var vrac = f.type === 'vrac';
    var nb = g.items.length;
    h += '<div class="gvma-opt gvma-opt--qte"><div class="gvma-h"><span class="gvma-k">' + (f.type === 'cal' ? gvTr('gv.gv_module_achat_js.calibre_html', 'Calibre') : gvTr('gv.gv_module_achat_js.quantite_html', 'Quantité')) +
      ((!montrerFormat && f.type === 'vrac' && !data.brut) ? btnI('vrac', gvTr('gv.gv_module_achat_js.aide_vrac_aria_html', 'Comprendre la vente au poids')) : '') + '</span>';
    if ((f.type === 'gousse' || f.type === 'tube') && g.maxR > 0) h += gvTr('gv.gv_module_achat_js.degressif_html', '<span class="gvma-hint">Prix dégressif · jusqu’à −') + g.maxR + gvTr('gv.gv_module_achat_js.pct_par_html', ' % par ') + (f.type === 'tube' ? gvTr('gv.gv_module_achat_js.tube_html', 'tube') : gvTr('gv.gv_module_achat_js.gousse_html', 'gousse')) + '</span>';
    if (vrac && f.groups.length > 1) {
      h += gvTr('gv.gv_module_achat_js.calibre_vrac_aria_html', '<span class="gvma-vt" role="group" aria-label="Calibre du vrac">');
      f.groups.forEach(function (gr, i) {
        h += '<button type="button" class="custom-button' + (i === st.grp ? ' on' : '') + '" data-gvma-grp="' + i + '" aria-pressed="' + (i === st.grp) + '">' + esc(gr.cm || gvTr('gv.gv_module_achat_js.sans_calibre_html', 'Sans calibre')) + '</button>';
      });
      h += '</span>';
    }
    h += '</div><div class="gvma-tiles gvma-tiles--' + Math.min(Math.max(nb, 1), 4) + '">';
    g.items.forEach(function (i) { h += tuile(i, String(i.id) === String(it.id)); });
    h += '</div></div>';
    /* Conditionnement */
    var GVMA_TUBE = '<svg class="gvt" viewBox="0 0 24 34" aria-hidden="true" focusable="false"><path d="M8.4 8.2v22.4c0 1 .7 1.7 1.7 1.7h3.8c1 0 1.7-.7 1.7-1.7V8.2" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/><path class="gvt-r" d="M10.1 11v17.5" stroke="currentColor" stroke-width=".6" stroke-linecap="round" opacity=".35"/><g class="gvt-g" fill="currentColor"><path d="M10.71 9.71 10.58 10.91 10.47 12.21 10.40 13.59 10.37 15.04 10.36 16.56 10.37 18.12 10.40 19.72 10.45 21.35 10.53 22.99 10.63 24.62 10.75 26.24 10.90 27.84 11.09 29.40 11.31 30.90 11.69 30.90 11.86 29.39 12.00 27.82 12.10 26.22 12.15 24.59 12.18 22.95 12.18 21.31 12.15 19.68 12.09 18.07 12.01 16.50 11.90 14.99 11.75 13.53 11.57 12.16 11.35 10.87 11.09 9.69Z"/><path d="M13.21 9.89 12.98 11.22 12.78 12.61 12.64 14.05 12.55 15.52 12.50 17.02 12.47 18.54 12.48 20.08 12.49 21.62 12.53 23.17 12.57 24.70 12.63 26.23 12.69 27.74 12.76 29.22 12.81 30.68 13.19 30.72 13.46 29.27 13.70 27.78 13.86 26.26 13.97 24.72 14.04 23.17 14.07 21.62 14.07 20.07 14.05 18.53 14.01 17.01 13.95 15.52 13.88 14.06 13.79 12.63 13.68 11.25 13.59 9.91Z"/></g><rect x="7.6" y="1.6" width="8.8" height="6.4" rx="1" fill="var(--gvt-bg,#fff)" stroke="currentColor" stroke-width="1.2"/><path d="M10.2 3.6v2.2M12 3.6v2.2M13.8 3.6v2.2" stroke="currentColor" stroke-width=".9" stroke-linecap="round"/></svg>';
    if (c.cond === 'switch' && it.a) {
      var n = nbTubes(it) * st.qty, tp = data.tube.p;
      /* gvma-tube--bascule : la ligne vient d'être cochée ou décochée (le rendu remplace tout le HTML : les gousses
         glissent par une animation plutôt qu'une transition) */
      var gvmaBascule = rendreChoix.tubeAvant !== undefined && rendreChoix.tubeAvant !== st.tube;
      rendreChoix.tubeAvant = st.tube;
      h += '<div class="gvma-tube' + (st.tube ? ' on' : '') + (gvmaBascule ? ' gvma-tube--bascule' : '') + '" data-gvma-tube-row>' +
        '<button type="button" class="custom-button gvma-sw" role="switch" aria-checked="' + st.tube + '" aria-labelledby="gvma-tube-lab" data-gvma-tube><span class="gvma-sw__g"><i></i></span></button>' +
        /* tube dessiné (page produit « un seul style », 02/10/2026) : vide, il se remplit de gousses quand la ligne est cochée */
        '<span class="gvma-tube__ic" aria-hidden="true">' + GVMA_TUBE + '</span>' +
        gvTr('gv.gv_module_achat_js.conditionner_html', '<span class="gvma-tl"><span class="gvma-tl__b"><span id="gvma-tube-lab">Conditionner en tube</span>') + btnI('tube', gvTr('gv.gv_module_achat_js.tube_verre_aria_html', 'Le tube en verre')) + '</span>' +
        '<span class="gvma-tem">' + (st.tube ? (nbTubes(it) > 1 ? gvTr('gv.gv_module_achat_js.tube_tranche_html', 'Un tube par tranche de 10 gousses') : gvTr('gv.gv_module_achat_js.elegant_html', 'Élégant, idéal pour offrir'))
          : gvTr('gv.gv_module_achat_js.defaut_sachet_html', 'Par défaut : sachet de conservation offert') + btnI('sachet', gvTr('gv.gv_module_achat_js.sachet_aria_html', 'Le sachet de conservation'))) + '</span></span>' +
        '<span class="gvma-tp">' + (n > 1 ? n + gvTr('gv.gv_module_achat_js.tubes_sep_html', ' tubes · ') : '') + '+' + eur(n * tp) + '</span></div>';
    } else if (c.cond === 'offert') {
      h += '<div class="gvma-cond"><span class="gvma-tube__ic gvma-tube__ic--plein" aria-hidden="true">' + GVMA_TUBE + gvTr('gv.gv_module_achat_js.tube_offert_html', '</span>✓ Tube en verre offert avec cette vanille') + (data.givree ? gvTr('gv.gv_module_achat_js.givree_html', ' givrée') : '') + btnI('tube', gvTr('gv.gv_module_achat_js.tube_verre_aria_html', 'Le tube en verre')) + '</div>';
    } else if (c.cond === 'sachet') {
      h += gvTr('gv.gv_module_achat_js.sachet_offert_cond_html', '<div class="gvma-cond">✓ Sachet de conservation offert') + btnI('sachet', gvTr('gv.gv_module_achat_js.sachet_aria_html', 'Le sachet de conservation')) + '</div>';
    }
    /* garder le focus clavier sur l'élément équivalent après le rendu */
    var a = document.activeElement, cle = null;
    if (a && elChoix.contains(a)) {
      ['data-gvma-fmt', 'data-gvma-grp', 'data-gvma-id', 'data-gvma-tube', 'data-gvma-info'].some(function (k) {
        if (a.hasAttribute(k)) { cle = '[' + k + '="' + a.getAttribute(k) + '"]'; return true; }
        return false;
      });
    }
    elChoix.innerHTML = h;
    if (cle) { var b = elChoix.querySelector(cle); if (b) b.focus({ preventScroll: true }); }
  }

  /* ───────────── bouton, barres, express ───────────── */
  var sbar = null, mbar = null;
  function creerBarres() {
    var step = gvTr('gv.gv_module_achat_js.step_moins_html', '<div class="gvma-step"><button type="button" class="custom-button gvma-mn" data-gvma-moins aria-label="Retirer un lot">−</button>') +
      gvTr('gv.gv_module_achat_js.step_plus_html', '<span class="gvma-qv" data-gvma-qv>1</span><button type="button" class="custom-button gvma-pl" data-gvma-plus aria-label="Ajouter un lot">+</button></div>');
    var atc = gvTr('gv.gv_module_achat_js.atc_html', '<button type="button" class="custom-button gvma-atc" data-gvma-atc><span class="gvma-atc__t" data-gvma-atc-t>Ajouter<span class="gvma-ap"> au panier</span></span>') +
      '<span class="gvma-atc__sep"></span><span class="gvma-atc__pn" data-gvma-pn></span><s class="gvma-atc__po" data-gvma-po></s></button>';
    sbar = document.createElement('div');
    sbar.className = 'gvma-sb';
    sbar.setAttribute('aria-hidden', 'true');
    sbar.innerHTML = '<div class="gvma-sb__in">' + (data.img ? '<img src="' + esc(data.img) + '" alt="" width="44" height="44">' : '') +
      '<div class="gvma-sb__tx"><div class="gvma-sb__nm">' + esc(data.titre) + '</div><div class="gvma-sb__sel" data-gvma-sel></div>' +
      '<p class="gvma-berr" data-gvma-berr hidden></p></div>' +
      step + atc + '</div>';
    mbar = document.createElement('div');
    mbar.className = 'gvma-mb';
    mbar.innerHTML = '<p class="gvma-berr" data-gvma-berr hidden></p><div class="gvma-mb__sel" data-gvma-sel></div><div class="gvma-mb__row">' + step.replace('data-gvma-qv>', 'data-gvma-qv aria-live="polite">') + atc + '</div>';
    document.body.appendChild(sbar);
    document.body.appendChild(mbar);
    document.documentElement.classList.add('gvma-page');
    /* téléphone : le bas de page réserve exactement la hauteur de la barre fixe (zone de sécurité comprise) */
    function reserve() { if (mbar.offsetHeight) document.documentElement.style.setProperty('--gvma-mb-h', mbar.offsetHeight + 'px'); }
    reserve();
    window.addEventListener('resize', function () { reserve(); ajusteBoutons(); }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(reserve).observe(mbar);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { reserve(); ajusteBoutons(); });
  }

  function majAchat(anim) {
    var c = calc();
    var all = [root, sbar, mbar];
    all.forEach(function (z) {
      if (!z) return;
      z.classList.toggle('is-oos', c.oos);
      z.querySelectorAll('[data-gvma-qv]').forEach(function (e) { e.textContent = st.qty; });
      z.querySelectorAll('[data-gvma-moins]').forEach(function (e) { e.setAttribute('aria-disabled', st.qty <= 1 ? 'true' : 'false'); });
      z.querySelectorAll('[data-gvma-plus]').forEach(function (e) { e.setAttribute('aria-disabled', st.qty >= qteMax() ? 'true' : 'false'); });
      z.querySelectorAll('[data-gvma-sel]').forEach(function (e) {
        /* page coffret : ligne de la barre rendue par le serveur (ordinateur / téléphone, en stock / en rupture) */
        e.textContent = COF ? (z === mbar ? (c.oos ? data.selMoos : data.selM) : (c.oos ? data.selDoos : data.selD)) || c.sel : c.sel;
      });
      z.querySelectorAll('[data-gvma-atc]').forEach(function (b) {
        if (st.busy) return;
        var t = b.querySelector('[data-gvma-atc-t]');
        t.innerHTML = c.oos ? gvTr('gv.gv_module_achat_js.prevenez_html', 'Prévenez-moi du retour') : gvTr('gv.gv_module_achat_js.ajouter_html', 'Ajouter<span class="gvma-ap"> au panier</span>');
        b.classList.toggle('has-po', !c.oos && c.remise);
        b.setAttribute('aria-label', c.oos ? gvTr('gv.gv_module_achat_js.prevenez_aria_html', 'Prévenez-moi du retour de ') + c.sel : gvTr('gv.gv_module_achat_js.ajouter_aria_html', 'Ajouter au panier : ') + c.sel + ', ' + eur(c.prix));
      });
      z.querySelectorAll('[data-gvma-pn]').forEach(function (e) {
        e.textContent = c.oos ? '' : eur(c.prix);
        if (anim) { e.classList.remove('gvma-flash'); void e.offsetWidth; e.classList.add('gvma-flash'); }
      });
      z.querySelectorAll('[data-gvma-po]').forEach(function (e) { e.textContent = (!c.oos && c.remise) ? eur(c.brut) : ''; });
    });
    if (!st.busy) erreur('');
    ajusteBoutons();
  }

  /* Le texte du bouton tient toujours, quel que soit l'écran et le montant : s'il manque de place,
     on retire d'abord « au panier », puis le prix barré (mesure réelle, pas de seuil d'écran). */
  function ajusteBoutons() {
    document.querySelectorAll('.gvma-atc').forEach(function (b) {
      b.classList.remove('serre-1', 'serre-2');
      var br = b.getBoundingClientRect();
      if (!br.width) return;
      function deborde() {
        var g = Infinity, d = -Infinity;
        [].forEach.call(b.querySelectorAll('.gvma-atc__t, .gvma-atc__sep, .gvma-atc__pn, .gvma-atc__po'), function (c) {
          var r = c.getBoundingClientRect();
          if (!r.width) return;
          g = Math.min(g, r.left); d = Math.max(d, r.right);
        });
        return d - g > br.width - 20;
      }
      if (deborde()) b.classList.add('serre-1');
      if (deborde()) b.classList.add('serre-2');
    });
  }

  function tout(anim) { rendreChoix(); majAchat(anim); }

  /* ───────────── ajout au panier ───────────── */
  var srStatut = document.createElement('span'), srAlerte = document.createElement('span');
  srStatut.className = srAlerte.className = 'gvma-sr';
  srStatut.setAttribute('role', 'status');
  srAlerte.setAttribute('role', 'alert');
  root.appendChild(srStatut);
  root.appendChild(srAlerte);
  function erreur(msg) {
    [elErr].concat([].slice.call(document.querySelectorAll('[data-gvma-berr]'))).forEach(function (e) {
      if (!e) return;
      e.textContent = msg;
      e.hidden = !msg;
    });
    srAlerte.textContent = msg;
  }
  function etatBoutons(txt, busy) {
    [root, sbar, mbar].forEach(function (z) {
      if (!z) return;
      z.querySelectorAll('[data-gvma-atc]').forEach(function (b) {
        b.setAttribute('aria-disabled', busy ? 'true' : 'false');
        b.classList.toggle('is-busy', !!busy);
        if (txt) { b.querySelector('[data-gvma-atc-t]').textContent = txt; b.setAttribute('aria-label', txt); }
      });
    });
    if (txt) srStatut.textContent = txt;
  }
  function relirePanier() {
    return fetch(gvUrl('/cart.js')).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.header-cart-count, [data-cart-count], .cart-count').forEach(function (e) { e.textContent = (window.gvNbArticles ? window.gvNbArticles(cart) : cart.item_count); });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      return cart;
    });
  }
  /* 12/10/2026 : le tube est rattaché au FORMAT choisi (propriété « Format » = titre exact de la variante),
     avec le tube nommé par taille quand il existe (« tb »). « leg » : panier d'avant le 12/10, même forme qu'avant. */
  function ligneTube(c) {
    var q = c.tubesLot * st.qty;
    if (data.tube.leg && +c.it.id === +data.tube.legv) return { id: +data.tube.leg, quantity: q, properties: { Pour: data.titre } };
    return { id: +(c.it.tb || data.tube.id), quantity: q, properties: { Pour: (FRV && FRV.titre) || data.titre, Format: (FRV && FRV.vt && FRV.vt[c.it.id]) || c.it.vt } };
  }
  function ajouter() {
    if (st.busy) return;
    var c = calc();
    if (c.oos) {
      if (window.GVBIS && GVBIS.open) GVBIS.open(String(c.it.id), COF ? 'coffret' : undefined);
      return;
    }
    if (FRP && !FRV && c.tubesLot > 0 && data.tube) { FRP.then(ajouter); return; }
    var lignes = [{ id: +c.it.id, quantity: st.qty }];
    if (c.tubesLot > 0 && data.tube) lignes.push(ligneTube(c));
    st.busy = true;
    etatBoutons(gvTr('gv.gv_module_achat_js.ajout_en_cours_html', 'Ajout en cours…'), true);
    fetch(gvUrl('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: lignes })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || ''); e.gv = 1; e.partiel = r.status === 422; throw e; }
        return j;
      });
    }).then(function () {
      return relirePanier();
    }).then(function () {
      etatBoutons(gvTr('gv.gv_module_achat_js.ajoute_html', '✓ Ajouté'), true);
      setTimeout(function () { st.busy = false; etatBoutons(null, false); majAchat(false); }, 1500);
    }).catch(function (e) {
      st.busy = false;
      etatBoutons(null, false);
      majAchat(false);
      erreur((e && e.gv && e.message) ? e.message : gvTr('gv.gv_module_achat_js.err_ajout_html', 'L’ajout au panier n’a pas abouti. Merci de réessayer.'));
      /* stock insuffisant : Shopify a pu ajouter une partie. Compteur et contenu du panier mis à jour
         sans l'ouvrir : ouvert, il recouvrirait le message qui explique ce qui s'est passé. */
      if (e && e.partiel) {
        fetch(gvUrl('/cart.js')).then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('.header-cart-count, [data-cart-count], .cart-count').forEach(function (x) { x.textContent = (window.gvNbArticles ? window.gvNbArticles(cart) : cart.item_count); });
          var sc = document.querySelector('side-cart');
          if (sc && sc.reloadSidecart) sc.reloadSidecart();
        }).catch(function () {});
      }
    });
  }

  /* ───────────── paiement direct ─────────────
     Même envoi que « Ajouter au panier », puis la page de paiement Shopify (Shop Pay, PayPal,
     Apple Pay y sont proposés en tête). gv-cadeaux.js ajoute le tube offert et la gousse surprise
     0,6 à 1,5 s après toute écriture panier : on attend que le panier ne bouge plus avant de partir. */
  function attendre(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function empreinte() {
    return fetch(gvUrl('/cart.js'), { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { return c.item_count + ':' + c.total_price + ':' + c.items.length; });
  }
  function panierStable() {
    var debut = Date.now(), prec = null;
    function tour() {
      return empreinte().then(function (e) {
        if ((e === prec && Date.now() - debut > 1800) || Date.now() - debut > 5000) return;
        prec = e;
        return attendre(450).then(tour);
      }, function () { if (Date.now() - debut > 5000) return; return attendre(450).then(tour); });
    }
    return attendre(900).then(tour);
  }
  function payerDirect(btn) {
    if (st.busy) return;
    var c = calc();
    if (c.oos) return;
    if (FRP && !FRV && c.tubesLot > 0 && data.tube) { FRP.then(function () { payerDirect(btn); }); return; }
    var lignes = [{ id: +c.it.id, quantity: st.qty }];
    if (c.tubesLot > 0 && data.tube) lignes.push(ligneTube(c));
    var libelle = btn.innerHTML;
    st.busy = true;
    etatBoutons(null, true);
    btn.classList.add('is-busy');
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = gvTr('gv.gv_module_achat_js.preparation_html', 'Préparation du paiement…');
    srStatut.textContent = gvTr('gv.gv_module_achat_js.preparation_html', 'Préparation du paiement…');
    fetch(gvUrl('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: lignes })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || ''); e.gv = 1; e.partiel = r.status === 422; throw e; }
        return j;
      });
    }).then(panierStable).then(function () {
      window.location.href = gvUrl('/checkout');
    }).catch(function (e) {
      st.busy = false;
      btn.innerHTML = libelle;
      btn.classList.remove('is-busy');
      btn.setAttribute('aria-disabled', 'false');
      etatBoutons(null, false);
      majAchat(false);
      erreur((e && e.gv && e.message) ? e.message : gvTr('gv.gv_module_achat_js.err_paiement_html', 'Le passage au paiement n’a pas abouti. Merci de réessayer.'));
      if (e && e.partiel) {
        fetch(gvUrl('/cart.js')).then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('.header-cart-count, [data-cart-count], .cart-count').forEach(function (x) { x.textContent = (window.gvNbArticles ? window.gvNbArticles(cart) : cart.item_count); });
          var sc = document.querySelector('side-cart');
          if (sc && sc.reloadSidecart) sc.reloadSidecart();
        }).catch(function () {});
      }
    });
  }

  /* ───────────── petites explications (fenêtres « i ») ───────────── */
  var modal = null, retourFocus = null;
  function creerModal() {
    modal = document.createElement('div');
    modal.className = 'gvma-modal';
    modal.innerHTML = '<div class="gvma-mcard" role="dialog" aria-modal="true" aria-labelledby="gvma-mtitle">' +
      gvTr('gv.gv_module_achat_js.fermer_html', '<button type="button" class="custom-button gvma-mclose" aria-label="Fermer">×</button>') +
      '<div class="gvma-mvis"></div><div class="gvma-mtitle" id="gvma-mtitle"></div><div class="gvma-mtext"></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('.gvma-mclose')) fermerInfo();
    });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); fermerInfo(); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(modal.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])'));
      if (!f.length) return;
      var i = f.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    });
  }
  function fermerInfo() {
    if (!modal) return;
    modal.classList.remove('open');
    document.documentElement.classList.remove('gvma-modal-ouverte');
    if (retourFocus && document.contains(retourFocus)) retourFocus.focus({ preventScroll: true });
  }
  function pkgPopup(k) {
    var d = {};
    try { d = JSON.parse(document.getElementById('gv-pkg-popup-data').textContent)[k] || {}; } catch (e) {}
    return d;
  }
  function remplace(txt, vals) {
    return String(txt || '').replace(/\{(\w+)\}/g, function (m, k) { return vals[k] != null ? esc(vals[k]) : m; });
  }
  function calibresGousses() {
    var out = [];
    M.formats.forEach(function (f) {
      if ((f.type !== 'gousse' && f.type !== 'vrac') || !f.cm) return;
      var m = f.cm.match(/^(\d+)\/(\d+) cm$/);
      if (m && !out.some(function (o) { return o.cm === f.cm; })) out.push({ cm: f.cm, mini: +m[1], maxi: +m[2] });
    });
    return out;
  }
  /* règle : les calibres de la fiche en gousses à l'échelle, le format choisi en foncé.
     Gousse = gravure choisie par Paul le 25/09 (assets/gv-gousse-gravure.png : pastille « 1 » retirée,
     partie qu'elle cachait refaite avec les traits de la gravure elle-même). De la pointe au bout du
     crochet de la tige = calibre maximal ; proportions de la gravure gardées (GOUSSE_RATIO = hauteur /
     largeur de l'image). Le format choisi en noir, l'autre en gris clair. */
  var GOUSSE_RATIO = 0.205;
  function regle(sel) {
    var cals = calibresGousses();
    var R = Math.max(20, Math.ceil(Math.max.apply(null, cals.map(function (c) { return c.maxi; }).concat([0]))));
    var x0 = 36, u = 300 / R, F2 = 'font-family="Assistant,sans-serif"';
    var y = 30, s = '';
    cals.forEach(function (c) {
      var on = c.cm === sel, t = on ? '#1F1F1F' : '#A39E95';
      var si = sizeInfo(c.cm);
      var nom = (nomLisible(si && si.name) || gvTr('gv.gv_module_achat_js.calibre_html', 'Calibre')).toUpperCase() + ' · ' + c.cm.toUpperCase();
      var poids = si && si.w ? si.w.replace(/(\d)\s*g\b/, '$1 g') : '';
      var w = c.maxi * u, h = w * GOUSSE_RATIO;
      s += '<text x="' + x0 + '" y="' + y + '" ' + F2 + ' font-size="10.5" letter-spacing="1.3" font-weight="' + (on ? 700 : 500) + '" fill="' + t + '">' + esc(nom) + '</text>' +
        '<text x="' + (x0 + 300) + '" y="' + y + '" text-anchor="end" ' + F2 + ' font-size="11" fill="' + t + '">' + esc(poids) + '</text>';
      s += '<image href="' + esc(gousseSrc) + '" x="' + x0 + '" y="' + (y + 8) + '" width="' + w.toFixed(1) + '" height="' + h.toFixed(1) + '" preserveAspectRatio="none"' + (on ? '' : ' opacity=".3"') + '/>';
      s += '<rect x="' + (x0 + c.mini * u).toFixed(1) + '" y="{BANDE}" width="' + ((c.maxi - c.mini) * u).toFixed(1) + '" height="5" rx="1" fill="' + (on ? '#2E1B10' : '#CFC7BB') + '"/>';
      y += 8 + h + 30;
    });
    var yl = y - 6, H = yl + 36;
    s = s.replace(/\{BANDE\}/g, String(yl - 6));
    s += '<line x1="' + x0 + '" y1="' + yl + '" x2="' + (x0 + 300) + '" y2="' + yl + '" stroke="#8F8F8F" stroke-width="1"/>';
    for (var i = 0; i <= R; i++) {
      var x = x0 + i * u, tk = (i % 5 === 0) ? 8 : 4;
      s += '<line x1="' + x + '" y1="' + yl + '" x2="' + x + '" y2="' + (yl + tk) + '" stroke="#8F8F8F" stroke-width="1"/>';
      if (i % 5 === 0) s += '<text x="' + x + '" y="' + (yl + 22) + '" text-anchor="middle" ' + F2 + ' font-size="10" fill="#8F8F8F">' + i + (i + 5 > R ? ' cm' : '') + '</text>';
    }
    return '<svg viewBox="0 0 372 ' + Math.ceil(H) + '" aria-hidden="true" focusable="false"><rect width="372" height="' + Math.ceil(H) + '" fill="#FAFAF8"/>' + s + '</svg>';
  }
  /* graphique du vrac : prix au kilo de chaque poids, remise comprise, le plus avantageux en foncé */
  function vracSVG(g) {
    var its = g.items.filter(function (i) { return i.grams > 0; });
    var F2 = 'font-family="Assistant,sans-serif"';
    var vals = its.map(function (i) { return i.f / (i.grams / 1000); });
    var max = Math.max.apply(null, vals), min = Math.min.apply(null, vals);
    var n = its.length, slot = 300 / Math.max(n, 1), w = Math.min(60, slot * 0.6);
    var s = '<svg viewBox="0 0 372 220" aria-hidden="true" focusable="false"><rect width="372" height="220" fill="#FAFAF8"/>' +
      '<text x="36" y="32" ' + F2 + gvTr('gv.gv_module_achat_js.prix_au_kilo_svg_html', ' font-size="10.5" letter-spacing="1.3" font-weight="700" fill="#1F1F1F">PRIX AU KILO') + (g.cm ? ' · ' + esc(g.cm.toUpperCase()) : '') + '</text>';
    its.forEach(function (it, i) {
      var h = Math.round(118 * vals[i] / max), x = 36 + slot * i + (slot - w) / 2, y = 182 - h;
      s += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="' + (vals[i] === min ? '#2B1A10' : '#CFC7BB') + '"/>' +
        '<text x="' + (x + w / 2) + '" y="' + (y - 8) + '" text-anchor="middle" ' + F2 + ' font-size="11.5" font-weight="700" fill="#1F1F1F">' + String(Math.round(vals[i] / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €/kg</text>' +
        '<text x="' + (x + w / 2) + '" y="200" text-anchor="middle" ' + F2 + ' font-size="11" fill="#6D6A63">' + esc(it.label) + '</text>';
    });
    return s + '<line x1="36" y1="182" x2="336" y2="182" stroke="#8F8F8F" stroke-width="1"/></svg>';
  }
  function texteVrac() {
    var poids = [], cms = [];
    M.items.forEach(function (i) {
      if (i.kind !== 'vrac') return;
      if (i.cm && cms.indexOf(i.cm) < 0) cms.push(i.cm);
      var l = poidsLisible(i.grams); if (l && poids.indexOf(l) < 0) poids.push(l);
    });
    var dispo = poids.length > 1 ? poids.slice(0, -1).join(', ') + gvTr('gv.gv_module_achat_js.ou_html', ' ou ') + poids[poids.length - 1] : (poids[0] || '');
    var calv = cms.length ? gvTr('gv.gv_module_achat_js.en_html', ', en ') + cms.join(gvTr('gv.gv_module_achat_js.ou_en_html', ' ou en ')) : '';
    return remplace(data.txt.vrac, { poids_dispo: dispo, calibres_vrac: calv });
  }
  function ouvrirInfo(k, opener) {
    if (!modal) creerModal();
    var f = formatCourant(), vis = '', titre = '', texte = '', estRegle = false;
    if (k === 'sachet' || k === 'tube') {
      var d = pkgPopup(k);
      titre = d.title || (k === 'tube' ? gvTr('gv.gv_module_achat_js.titre_tube_html', 'Tube en verre') : gvTr('gv.gv_module_achat_js.titre_sachet_html', 'Sachet de conservation'));
      texte = esc(d.text || '');
      if (d.img) vis = '<img src="' + esc(d.img) + '" alt="' + esc(titre) + '">';
    } else if (k === 'vrac' || (k === 'fmt' && f.type === 'vrac' && !f.cm)) {
      var g = groupeCourant();
      vis = vracSVG(g);
      titre = gvTr('gv.gv_module_achat_js.titre_vrac_html', 'En vrac — au poids');
      texte = texteVrac();
    } else {
      var si = sizeInfo(f.cm) || {};
      var nom = si.name || gvTr('gv.gv_module_achat_js.titre_format_html', 'Format');
      var cle = nom === 'Plus petites' ? 'pet' : nom === 'Grandes gousses' ? 'grand' : 'std';
      var pm = (si.w || '').match(/(\d+)\s*-\s*(\d+)\s*g/);
      var mm = f.cm.match(/^(\d+)\/(\d+) cm$/);
      vis = regle(f.cm); estRegle = true;
      titre = nomLisible(nom) + ' — ' + f.cm;
      texte = remplace(data.txt[cle], {
        calibre: mm ? mm[1] + gvTr('gv.gv_module_achat_js.a_html', ' à ') + mm[2] + ' cm' : f.cm,
        poids: pm ? pm[1] + gvTr('gv.gv_module_achat_js.a_html', ' à ') + pm[2] + ' g' : ''
      }).replace(new RegExp(gvTr('gv.logique_fiche.re_environ_html', ',\\s*d’environ\\s+chacune')), '');
      /* fiche vendue au poids par calibre (fiches pro) : l'explication du vrac suit celle du calibre */
      if (f.type === 'vrac') texte += texteVrac();
    }
    modal.querySelector('.gvma-mvis').innerHTML = vis;
    modal.querySelector('.gvma-mvis').style.display = vis ? '' : 'none';
    modal.querySelector('.gvma-mvis').classList.toggle('gvma-mvis--regle', estRegle);
    modal.querySelector('.gvma-mtitle').textContent = titre;
    modal.querySelector('.gvma-mtext').innerHTML = texte;
    retourFocus = opener || null;
    modal.classList.add('open');
    document.documentElement.classList.add('gvma-modal-ouverte');
    modal.querySelector('.gvma-mclose').focus({ preventScroll: true });
  }

  /* ───────────── événements ───────────── */
  function clic(e) {
    var t = e.target;
    var i = t.closest('[data-gvma-info]');
    if (i) { e.preventDefault(); e.stopPropagation(); ouvrirInfo(i.getAttribute('data-gvma-info'), i); return; }
    var b;
    if ((b = t.closest('[data-gvma-fmt]'))) {
      var ancien = article();
      choisirFormat(+b.getAttribute('data-gvma-fmt'));
      var jumeau = groupeCourant().items.filter(function (i) {
        return i.a && i.kind === ancien.kind && (i.kind === 'vrac' ? i.grams === ancien.grams : i.q === ancien.q);
      })[0];
      if (jumeau) st.id = jumeau.id;
      if (st.qty > qteMax()) st.qty = qteMax();
      tout(true); return;
    }
    if ((b = t.closest('[data-gvma-grp]'))) {
      var avant = article();
      st.grp = +b.getAttribute('data-gvma-grp');
      var meme = groupeCourant().items.filter(function (i) { return i.grams === avant.grams && i.a; })[0];
      st.id = (meme || premierDispo(groupeCourant().items)).id;
      tout(true); return;
    }
    if ((b = t.closest('[data-gvma-id]'))) { st.id = b.getAttribute('data-gvma-id'); if (st.qty > qteMax()) st.qty = qteMax(); tout(true); return; }
    if (t.closest('[data-gvma-tube-row]')) { st.tube = !st.tube; tout(true); return; }
    if (t.closest('[data-gvma-moins]')) { if (st.qty > 1) { st.qty--; tout(true); } return; }
    if (t.closest('[data-gvma-plus]')) { if (st.qty < qteMax()) { st.qty++; tout(true); } return; }
    if (t.closest('[data-gvma-atc]')) { e.preventDefault(); ajouter(); return; }
    if ((b = t.closest('[data-gvma-direct]'))) { e.preventDefault(); payerDirect(b); }
  }
  root.addEventListener('click', clic);
  /* la gravure (≈ 12 Ko) est chargée dès qu'on approche un bouton « i » : elle est prête à l'ouverture */
  var gousseDemandee = false;
  function approche(e) {
    if (gousseDemandee || !gousseSrc || !e.target.closest || !e.target.closest('[data-gvma-info]')) return;
    gousseDemandee = true;
    var im = new Image(); im.src = gousseSrc;
  }
  root.addEventListener('pointerover', approche, { passive: true });
  root.addEventListener('focusin', approche);

  creerBarres();
  sbar.addEventListener('click', clic);
  mbar.addEventListener('click', clic);

  /* ordinateur : la barre fine n'apparaît que si le bouton principal est visible à moins de 75 % */
  var atcPrincipal = elAct.querySelector('[data-gvma-atc]');
  function montrerSb(v) {
    sbar.classList.toggle('on', v);
    sbar.setAttribute('aria-hidden', v ? 'false' : 'true');
    sbar.querySelectorAll('button').forEach(function (b) { b.tabIndex = v ? 0 : -1; });
  }
  function hautHeader() {
    var h = document.querySelector('header-js, .header-js');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return r.bottom > 0 && r.top <= 0 ? r.bottom : 0;
  }
  function verifieSb() {
    var r = atcPrincipal.getBoundingClientRect();
    if (!r.height) { montrerSb(false); return; }
    var haut = hautHeader(), bas = window.innerHeight;
    var vu = Math.min(r.bottom, bas) - Math.max(r.top, haut);
    montrerSb(vu < r.height * 0.75);
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(verifieSb, { threshold: [0, 0.25, 0.5, 0.75, 1] }).observe(atcPrincipal);
  }
  var attente = null;
  window.addEventListener('scroll', function () {
    if (attente) return;
    attente = setTimeout(function () { attente = null; verifieSb(); }, 80);
  }, { passive: true });
  window.addEventListener('resize', verifieSb, { passive: true });
  montrerSb(false);

  tout(false);
  setTimeout(verifieSb, 0);
  window.addEventListener('load', function () {
    setTimeout(function () {
      ['sachet', 'tube'].forEach(function (k) { var d = pkgPopup(k); if (d.img) { var im = new Image(); im.src = d.img; } });
    }, 1200);
  });
  /* les repères de format viennent de GV.sizeInfo (gv-selector.js, chargé en defer) */
  function quandGV() { if (window.GV && GV.sizeInfo) rendreChoix(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', quandGV);
  else quandGV();
})();
